import api from '.';

export interface ProjectStatus {
  id: number;
  name: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
}

interface GetProjectStatusesResponse {
  data: ProjectStatus[];
}

export async function getProjectStatuses(): Promise<GetProjectStatusesResponse> {
  const { data } = await api.get('/project-statuses');
  return data;
}

export async function getProjectStatus(id: number): Promise<ProjectStatus> {
  const { data } = await api.get(`/project-statuses/${id}`);
  return data;
}